import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Button from "components/shared/Button/Button";

export const MemberColumnContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  justifyContent: "space-around"
}));

export const MemberColumnBottomContainer = styled("div")(({ theme }) => ({
  width: "60%"
}));

export const MemberColumnUpperContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "left"
}));

export const InnerRow = styled("div")(({ theme }) => ({
  display: "flex",
  "& div:nth-child(1)": {
    width: "25%"
  },
  "& div:nth-child(2)": {
    width: "75%",
    textOverflow: "ellipsis"
  }
}));

export const StyledMainContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(19.5),
  bottom: theme.spacing(10),
  right: 10,
  left: 10
}));

export const StyledHeader = styled("h2")(({ theme }) => ({
  display: "flex",
  flex: "left",
  marginTop: 0,
  marginBottom: theme.spacing(4)
}));

export const StyledFont = styled("div")(({ theme }) => ({
  color: theme.palette.primary.light,
  fontFamily: "Helvetica Neue",
  fontSize: theme.spacing(2),
  fontWeight: "bold",
  "&:hover": {
    cursor: "pointer"
  },
  padding: 0
}));

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .MuiDataGrid-columnHeader": {
    color: "white",
    background: theme.palette.primary.light,
    fontSize: theme.spacing(2.4),
    width: "100%"
  },
  "& .super-app-theme--rows": {
    border: `ridge 3px`
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({}));

export const StyledMemberToolTipContainer = styled("div")(({ theme }) => ({
  width: theme.spacing(24)
}));

export const StyledMemberToolTipText = styled("h5")(({ theme }) => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  paddingBottom: theme.spacing(0.4),
  margin: theme.spacing(0)
}));

export const StyledLeftMemberToolTipGrid = styled(Grid)(({ theme }) => ({
  textAlign: "left"
}));

export const StyledRightMemberToolTipGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  textAlign: "left"
}));

export const StyledMeasurementToolTip = styled("div")(({ theme }) => ({
  width: theme.spacing(0),
  height: theme.spacing(0)
}));

export const StyledDot = styled("span")(({ theme }) => ({
  height: theme.spacing(3),
  width: theme.spacing(3),
  backgroundColor: "#f8a120",
  borderRadius: "50%",
  display: "inline-block"
}));

export const StyledRowReadingTileContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(0.3),
  border: `hidden 1px #000000`,
  display: "grid",
  placeItems: "center",
  height: "94%",
  width: "100%",
  borderRadius: "5px"
}));

export const StyledTileStack = styled("div")(({ theme }) => ({
  height: "100%",
  width: "50%"
}));

export const WrapperContainer = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  "&:hover": {
    cursor: "pointer"
  }
}));
